import { JSX, Suspense } from 'react';
import { SnackbarProvider } from '@aexae/design-system';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
// @ts-ignore - LEGACY
import { PersistGate } from 'redux-persist/lib/integration/react';
// @ts-ignore - LEGACY
import LoadingScreen from '@components/loadings/LoadingScreen';
// @ts-ignore - LEGACY
import { CollapseDrawerProvider } from '@app/contexts/CollapseDrawerContext';
// @ts-ignore - LEGACY
import { SettingsProvider } from '@app/contexts/SettingsContext';
// @ts-ignore - LEGACY
import { store, persistor } from '@app/redux/store';

import LocaleProvider from './LocaleProvider';
import QueryProvider from './QueryProvider';

const Providers = ({ children }: { children: JSX.Element }) => {
  return (
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={<LoadingScreen sx={{ pt: 20 }} />} persistor={persistor}>
          <QueryProvider>
            <SettingsProvider>
              {/* Suspense pour le chargement asynchrone des traductions i18next */}
              <Suspense fallback={<LoadingScreen sx={{ pt: 20 }} />}>
                <LocaleProvider>
                  <SnackbarProvider preventDuplicate>
                    <CollapseDrawerProvider>{children}</CollapseDrawerProvider>
                  </SnackbarProvider>
                </LocaleProvider>
              </Suspense>
            </SettingsProvider>
          </QueryProvider>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  );
};

export default Providers;
